import { useEffect, useState } from "react";
import useWebSocket from "react-use-websocket";

export type joystickEvent = "up" | "down" | "left" | "right" | "enter";

function useJoyStickNavigation(callback: (event: joystickEvent) => void) {
  const [url, setUrl] = useState("ws://localhost:8888/websocket/");
  const { sendMessage, lastMessage, readyState } = useWebSocket(url);

  useEffect(() => {
    console.log(lastMessage);
    if (lastMessage !== null) {
      const message = JSON.parse(lastMessage.data);
      if (message.type == "button") {
        callback(message.movement);
      }
    }
  }, [lastMessage]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case "ArrowDown":
          callback("down");
          break;
        case "ArrowLeft":
          callback("left");
          break;
        case "ArrowRight":
          callback("right");
          break;
        case "ArrowUp":
          callback("up");
          break;
        case "Enter":
          callback("enter");
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [callback]);

  const writeMessage = function (message: string) {
    sendMessage(message);
  };

  return { writeMessage };
}

export default useJoyStickNavigation;
